import {
	Col,
	Divider,
	Form,
	Input,
	Modal,
	Row,
	Flex,
	Checkbox,
	Typography,
	Carousel,
	Button,
	Image,
} from "antd";
import React, { useEffect, useState } from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const arrowBaseStyle = {
	position: "absolute",
	top: "50%",
	transform: "translateY(-50%)",
	zIndex: 1,
	fontSize: "20px",
	color: "#fff",
	cursor: "pointer",
	backgroundColor: "rgba(0,0,0,0.5)",
	borderRadius: "50%",
	width: "36px",
	height: "36px",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	transition: "background-color 0.3s ease",
};

const AfterWorkType = ({ job }) => {
	const [form] = Form.useForm();
	const [openSamplesModal, setOpenSamplesModal] = useState(false);
	const [openControlJointSpicingModal, setOpenControlJointSpicingModal] =
		useState(false);
	const [openCuringOfElementModal, setOpenCuringOfElementModal] =
		useState(false);
	const [openCylindersModal, setOpenCylindersModal] = useState(false);
	const [initialValues, setInitialValues] = useState({});

	useEffect(() => {
		if (job) {
			setInitialValues({
				afterWorkModulation: job.afterWorkModulation,
				afterWorkDepth: job.afterWorkDepth || 0,
				afterWorkSample: job.afterWorkSample,
				afterWorkModulationComments: job.afterWorkModulationComments,
				afterWorkControlJointSpicingWidth:
					job.afterWorkControlJointSpicingWidth || 0,
				afterWorkControlJointSpicingHeight:
					job.afterWorkControlJointSpicingHeight || 0,
				afterWorkControlJointSpicingUrl: job.afterWorkControlJointSpicingUrl,
				afterWorkCuringOfElement: job.afterWorkCuringOfElement,
				afterWorkCuringOfElementUrl: job.afterWorkCuringOfElementUrl,
				afterWorkCuringOfElementComments: job.afterWorkCuringOfElementComments,
				afterWorkCylinders: job.afterWorkCylinders || 0,
				afterWorkCylindersUrl: job.afterWorkCylindersUrl,
				afterWorkCylindersComments: job.afterWorkCylindersComments,
				afterWorkRemovedFromForm: job.afterWorkRemovedFromForm,
				afterWorkRemovedFromFormComments: job.afterWorkRemovedFromFormComments,
			});
		}
	}, [job]);

	const CustomPrevArrow = ({ onClick }) => (
		<div
			onClick={onClick}
			style={{
				...arrowBaseStyle,
				left: "12px",
			}}
			onMouseEnter={(e) =>
				(e.currentTarget.style.backgroundColor = "rgba(0,0,0,0.7)")
			}
			onMouseLeave={(e) =>
				(e.currentTarget.style.backgroundColor = "rgba(0,0,0,0.5)")
			}
		>
			<LeftOutlined />
		</div>
	);

	const CustomNextArrow = ({ onClick }) => (
		<div
			onClick={onClick}
			style={{
				...arrowBaseStyle,
				right: "12px",
			}}
			onMouseEnter={(e) =>
				(e.currentTarget.style.backgroundColor = "rgba(0,0,0,0.7)")
			}
			onMouseLeave={(e) =>
				(e.currentTarget.style.backgroundColor = "rgba(0,0,0,0.5)")
			}
		>
			<RightOutlined />
		</div>
	);

	const handleSamplesModal = () => {
		setOpenSamplesModal((prev) => !prev);
	};

	const RenderSamplesModal = () => {
		return (
			<Modal
				title={`Sample images in after work ${job.number}`}
				open={openSamplesModal}
				onCancel={handleSamplesModal}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1000}
			>
				<Carousel
					arrows
					infinite={false}
					prevArrow={<CustomPrevArrow />}
					nextArrow={<CustomNextArrow />}
				>
					{job.afterWorkSample.map((url, index) => {
						return (
							<div key={index}>
								<Image width={"100%"} src={url} />
								<Text>
									Sample Value {job.afterWorkSampleValues[index] || "0"}
								</Text>
							</div>
						);
					})}
				</Carousel>
			</Modal>
		);
	};

	const handleControlJointSpicingModal = () => {
		setOpenControlJointSpicingModal((prev) => !prev);
	};

	const RenderControlJointSpicingModal = () => {
		return (
			<Modal
				title={`Control joint spicing image in after work ${job.number}`}
				open={openControlJointSpicingModal}
				onCancel={handleControlJointSpicingModal}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1000}
			>
				<Image width={"100%"} src={job.afterWorkControlJointSpicingUrl} />
			</Modal>
		);
	};
	const handleCuringOfElementModal = () => {
		setOpenCuringOfElementModal((prev) => !prev);
	};

	const RenderCuringOfElementModal = () => {
		return (
			<Modal
				title={`Curing of element image in after work ${job.number}`}
				open={openCuringOfElementModal}
				onCancel={handleCuringOfElementModal}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1000}
			>
				<Image width={"100%"} src={job.afterWorkCuringOfElementUrl} />
			</Modal>
		);
	};
	const handleCylindersModal = () => {
		setOpenCylindersModal((prev) => !prev);
	};

	const RenderCylindersModal = () => {
		return (
			<Modal
				title={`Cylinder image in after work ${job.number}`}
				open={openCylindersModal}
				onCancel={handleCylindersModal}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1000}
			>
				<Image width={"100%"} src={job.afterWorkCylindersUrl} />
			</Modal>
		);
	};

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				style={{ marginTop: "20px" }}
				initialValues={initialValues}
			>
				<Row gutter={16}>
					<Col span={12} md={8}>
						<Form.Item
							label="Modulation"
							name="afterWorkModulation"
							valuePropName="checked"
						>
							<Checkbox disabled readOnly>
								Yes/No
							</Checkbox>
						</Form.Item>
					</Col>
					<Col span={12} md={8}>
						<Form.Item label="Depth (Inch)" name="afterWorkDepth">
							<Input size="large" readOnly />
						</Form.Item>
					</Col>
					<Col span={12} md={8}>
						<Form.Item label="After Work Samples" name="afterWorkSample">
							{job.afterWorkSample && job.afterWorkSample.length > 0 ? (
								<Button
									type="primary"
									size="large"
									onClick={handleSamplesModal}
								>
									View Samples
								</Button>
							) : (
								<Text>No images attached</Text>
							)}
						</Form.Item>
					</Col>
					<Col span={12} md={8}>
						<Form.Item label="Comments" name="afterWorkModulationComments">
							<Input.TextArea size="large" readOnly />
						</Form.Item>
					</Col>
					<Col span={12} md={8}>
						<Form.Item
							label="Control Joint Spicing Width"
							name="afterWorkControlJointSpicingWidth"
						>
							<Input size="large" readOnly />
						</Form.Item>
					</Col>
					<Col span={12} md={8}>
						<Form.Item
							label="Control Joint Spicing Height"
							name="afterWorkControlJointSpicingHeight"
						>
							<Input size="large" readOnly />
						</Form.Item>
					</Col>
					<Col span={12} md={8}>
						<Form.Item
							label="Control Joint Spicing Image"
							name="afterWorkControlJointSpicingUrl"
						>
							{job.afterWorkControlJointSpicingUrl ? (
								<Button
									type="primary"
									size="large"
									onClick={handleControlJointSpicingModal}
								>
									View Image
								</Button>
							) : (
								<Text>No image attached</Text>
							)}
						</Form.Item>
					</Col>
				</Row>
				<Divider />
				<Row gutter={16}>
					<Col span={12} md={8}>
						<Form.Item
							label="Curing of Element"
							name="afterWorkCuringOfElement"
							valuePropName="checked"
						>
							<Checkbox disabled readOnly>
								Yes/No
							</Checkbox>
						</Form.Item>
					</Col>
					<Col span={12} md={8}>
						<Form.Item
							label="Curing of Element Image"
							name="afterWorkCuringOfElementUrl"
						>
							{job.afterWorkCuringOfElementUrl ? (
								<Button
									type="primary"
									size="large"
									onClick={handleCuringOfElementModal}
								>
									View Image
								</Button>
							) : (
								<Text>No image attached</Text>
							)}
						</Form.Item>
					</Col>
					<Col span={12} md={8}>
						<Form.Item label="Comments" name="afterWorkCuringOfElementComments">
							<Input.TextArea size="large" readOnly />
						</Form.Item>
					</Col>
				</Row>
				<Divider />
				<Row gutter={16}>
					<Col span={12} md={8}>
						<Form.Item label="Cylinders" name="afterWorkCylinders">
							<Input size="large" readOnly />
						</Form.Item>
					</Col>
					<Col span={12} md={8}>
						<Form.Item label="Cylinders Image" name="afterWorkCylindersUrl">
							{job.afterWorkCylindersUrl ? (
								<Button
									type="primary"
									size="large"
									onClick={handleCylindersModal}
								>
									View Image
								</Button>
							) : (
								<Text>No image attached</Text>
							)}
						</Form.Item>
					</Col>
					<Col span={12} md={8}>
						<Form.Item label="Comments" name="afterWorkCylindersComments">
							<Input.TextArea size="large" readOnly />
						</Form.Item>
					</Col>
				</Row>
				<Divider />
				<Row gutter={16}>
					<Col span={12} md={8}>
						<Form.Item
							label="Removed From Form"
							name="afterWorkRemovedFromForm"
						>
							<Input size="large" readOnly />
						</Form.Item>
					</Col>
					<Col span={12} md={8}>
						<Form.Item label="Comments" name="afterWorkRemovedFromFormComments">
							<Input.TextArea size="large" readOnly />
						</Form.Item>
					</Col>
				</Row>
			</Form>
		);
	};

	return (
		<Flex vertical>
			<Title level={1}>After Work</Title>
			<CustomForm />
			<RenderSamplesModal />
			<RenderControlJointSpicingModal />
			<RenderCuringOfElementModal />
			<RenderCylindersModal />
		</Flex>
	);
};

export default AfterWorkType;
